import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { Box, Button, Menu, MenuItem } from '@mui/material'
import { ComponentProps, useState } from 'react'
import { NavLink } from 'react-router'

type LinkMeta = { to: string; label: string }
export const TopNav = (props: { boxProps?: ComponentProps<typeof Box> }) => {
  const [setupMenuAnchorEl, setSetupMenuAnchorEl] = useState<null | HTMLElement>(null)
  const setupMenuOpen = Boolean(setupMenuAnchorEl)
  const handleSetupMenuClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setSetupMenuAnchorEl(event.currentTarget)
  }
  const handleSetupMenuClose = () => {
    setSetupMenuAnchorEl(null)
  }

  const topLevelLinks: LinkMeta[] = [
    { to: '/projects', label: 'Projects' },
    { to: '/payment-entry', label: 'Payment Entry' },
  ]
  const setupLinks: LinkMeta[] = [
    { to: '/clients', label: 'Clients' },
    { to: '/vendors', label: 'Vendors' },
    { to: '/contacts', label: 'Contacts' },
  ]

  return (
    <Box
      {...props.boxProps}
      sx={{
        display: { xs: 'none', md: 'block' },
        borderLeft: '1px solid rgba(0, 0, 0, 0.15)',
        pl: 2,
        ml: 2,
        ...props.boxProps?.sx,
      }}
    >
      {topLevelLinks.map((link) => (
        <Button key={link.to} component={NavLink} to={link.to} sx={{ mx: { xs: 0, sm: 1 } }} variant="text">
          {link.label}
        </Button>
      ))}
      <Button
        id="setup-menu-button"
        aria-controls={setupMenuOpen ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={setupMenuOpen ? 'true' : undefined}
        onClick={handleSetupMenuClick}
        sx={{ mx: { xs: 0, sm: 1 } }}
        endIcon={
          <ExpandMoreIcon
            sx={{
              transform: setupMenuOpen ? 'rotate(180deg)' : 'rotate(0deg)',
              transition: 'transform 0.3s',
            }}
          />
        }
      >
        Setup
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={setupMenuAnchorEl}
        open={setupMenuOpen}
        onClose={handleSetupMenuClose}
        MenuListProps={{
          'aria-labelledby': 'setup-menu-button',
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        {setupLinks.map((link) => (
          <MenuItem
            key={link.to}
            component={NavLink}
            to={link.to}
            sx={{ mx: { xs: 0, sm: 1 } }}
            onClick={handleSetupMenuClose}
          >
            {link.label}
          </MenuItem>
        ))}
      </Menu>
    </Box>
  )
}
